export default __webpack_public_path__ + "static/media/fellow.farmer.logo.small.b0f668ab.png";